import { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { UserInfoService } from '../../services/UserInfo.Service';
import LoadingPage from '../../pages/Loading';

const PrivateRoute = ({ component: Component, render, ...rest }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    validate();
  }, []);

  const validate = async () => {
    const result = await UserInfoService.isUserLoggedIn(window.location.pathname);
    //console.log(result);
    setIsAllowed(result);
    setIsChecked(true);
  };

  if (!isChecked || !isAllowed) {
    // Show a loading spinner or blank page while checking
    return <LoadingPage />;
  }
  else{
    return (
      <Route
        {...rest}
        render={(props) =>
          render
            ? render(props)
            : Component
            ? <Component {...props} />
            : null
        }
      />
    );
    // return (
    //   <Route
    //     {...rest}
    //     render={(props) =>
    //       isAllowed
    //         ? render
    //           ? render(props)
    //           : Component
    //           ? <Component {...props} />
    //           : null
    //         : <Redirect to="/" />
    //     }
    //   />
    // );
  }
};

export default PrivateRoute;
